import {
  getDoubleDeepHMO,
  getDoubleDataPPO,
  getSingleDeepHMO,
  getTierHMO,
} from "../functions/planDetails";
import { IFullPlanDetail, IFullPlanDetailPPO } from "../interfaces/api";

export const compareField = (category: string, field: string, plans: any) => {
  const equal = plans.every((plan: any) => {
    const lobs = plans.map((plan: any) => {
      const lob = plan.PlanDetails[0]?.company[0]?.healthPlan[0]?.lob;
      if (lob === "HMO") {
        return "HMO";
      } else {
        return "PPO";
      }
    });

    function hasSameLob(lobs: string[]): boolean {
      if (lobs.length === 0) {
        return false;
      }

      const firstLob = lobs[0];

      return lobs.every((lob) => lob === firstLob);
    }

    const sameLobs = hasSameLob(lobs);
    if (sameLobs === false) {
      return false;
    }
    const lob = plan.PlanDetails[0]?.company[0]?.healthPlan[0]?.lob;
    if (lob === "HMO") {
      const hmoData = getDoubleDeepHMO(
        plan as IFullPlanDetail,
        category,
        field
      );
      return plans.every(
        (p: any) =>
          getDoubleDeepHMO(p as IFullPlanDetail, category, field)[0]
            ?.pbpBenefitDesc === hmoData[0]?.pbpBenefitDesc
      );
    } else if (lob === "PPO") {
      const ppoData = getDoubleDataPPO(plan as IFullPlanDetailPPO, field);
      return plans.every(
        (p: IFullPlanDetailPPO) =>
          getDoubleDataPPO(p as IFullPlanDetailPPO, field).pbpBenefitGroup
            .InNetwork === ppoData.pbpBenefitGroup.InNetwork &&
          getDoubleDataPPO(p as IFullPlanDetailPPO, field).pbpBenefitGroup
            .OutofNetwork === ppoData.pbpBenefitGroup.OutofNetwork
      );
    }
    return false;
  });
  return equal;
};

export const compareSingleHmoField = (field: string, plans: any) => {
  const equal = plans.every((plan: any) => {
    const lobs = plans.map((plan: any) => {
      const lob = plan.PlanDetails[0]?.company[0]?.healthPlan[0]?.lob;
      if (lob === "HMO") {
        return "HMO";
      } else {
        return "PPO";
      }
    });

    function hasSameLob(lobs: string[]): boolean {
      if (lobs.length === 0) {
        return false;
      }

      const firstLob = lobs[0];

      return lobs.every((lob) => lob === firstLob);
    }

    const sameLobs = hasSameLob(lobs);
    if (sameLobs === false) {
      return false;
    }
    const lob = plan.PlanDetails[0]?.company[0]?.healthPlan[0]?.lob;
    if (lob === "HMO") {
      const hmoData = getSingleDeepHMO(plan as IFullPlanDetail, field);

      return plans.every(
        (p: any) =>
          getSingleDeepHMO(p as IFullPlanDetail, field)[0]?.pbpBenefitDesc ===
          hmoData[0]?.pbpBenefitDesc
      );
    } else if (lob === "PPO") {
      const ppoData = getDoubleDataPPO(plan as IFullPlanDetailPPO, field);
      return plans.every(
        (p: any) =>
          getDoubleDataPPO(p as IFullPlanDetailPPO, field).pbpBenefitGroup
            .InNetwork === ppoData.pbpBenefitGroup.InNetwork &&
          getDoubleDataPPO(p as IFullPlanDetailPPO, field).pbpBenefitGroup
            .OutofNetwork === ppoData.pbpBenefitGroup.OutofNetwork
      );
    }
    return false;
  });
  return equal;
};

export const compareSimpleField = (plans: any, category: string) => {
  const values = plans.map((plan: any) => plan.PlanDetails[0][category]);
  const equal = values.every((value: any) => value === values[0]);
  return equal;
};

export const compareTierField = (field: string, plans: any) => {
  const equal = plans.every((plan: any) => {
    const lobs = plans.map((plan: any) => {
      const lob = plan.PlanDetails[0]?.company[0]?.healthPlan[0]?.lob;
      if (lob === "HMO") {
        return "HMO";
      } else {
        return "PPO";
      }
    });

    function hasSameLob(lobs: string[]): boolean {
      if (lobs.length === 0) {
        return false;
      }

      const firstLob = lobs[0];

      return lobs.every((lob) => lob === firstLob);
    }

    const sameLobs = hasSameLob(lobs);
    if (sameLobs === false) {
      return false;
    }
    const lob = plan.PlanDetails[0]?.company[0]?.healthPlan[0]?.lob;
    if (lob === "HMO") {
      const hmoData = getTierHMO(plan as IFullPlanDetail, field);

      return plans.every(
        (p: any) =>
          getTierHMO(p as IFullPlanDetail, field).pbpBenefitGroup
            .MailOrderStandard === hmoData.pbpBenefitGroup.MailOrderStandard
      );
    } else if (lob === "PPO") {
      const ppoData = getDoubleDataPPO(plan as IFullPlanDetailPPO, field);
      return plans.every(
        (p: any) =>
          getDoubleDataPPO(p as IFullPlanDetailPPO, field).pbpBenefitGroup
            .InNetwork === ppoData.pbpBenefitGroup.InNetwork &&
          getDoubleDataPPO(p as IFullPlanDetailPPO, field).pbpBenefitGroup
            .OutofNetwork === ppoData.pbpBenefitGroup.OutofNetwork
      );
    }
    return false;
  });
  return equal;
};
